import { render, staticRenderFns } from "./OwnersTableUpdated.vue?vue&type=template&id=51bd37ae&"
import script from "./OwnersTableUpdated.vue?vue&type=script&lang=js&"
export * from "./OwnersTableUpdated.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports